( function ( window, document, config ) {
	'use strict';

	if (
		! window ||
		! document ||
		! config ||
		! config.endpoint ||
		! config.token
	) {
		return;
	}

	const endpoint = config.endpoint;
	const token = config.token;
	const recentEvents = new Map();

	function toInt( value ) {
		const parsed = Number( value );

		if ( Number.isFinite( parsed ) ) {
			return Math.max( 0, Math.floor( parsed ) );
		}

		return 0;
	}

	function readDataset( element ) {
		return {
			event_name: element.getAttribute( 'data-analytics-event' ) || '',
			entity_type:
				element.getAttribute( 'data-analytics-entity-type' ) || 'site',
			entity_id: toInt(
				element.getAttribute( 'data-analytics-entity-id' )
			),
			bakery_id: toInt(
				element.getAttribute( 'data-analytics-bakery-id' )
			),
			product_id: toInt(
				element.getAttribute( 'data-analytics-product-id' )
			),
			source_group: element.getAttribute( 'data-analytics-source' ) || '',
			payload: {
				label: element.getAttribute( 'data-analytics-label' ) || '',
				href: element.getAttribute( 'href' ) || '',
			},
		};
	}

	function isDuplicate( event ) {
		const dedupeWindow = 500;
		const key = [
			event.event_name,
			event.entity_type,
			event.entity_id,
			event.bakery_id,
			event.product_id,
			event.source_group,
		].join( '|' );
		const now = Date.now();
		const lastSeen = recentEvents.get( key ) || 0;

		if ( now - lastSeen < dedupeWindow ) {
			return true;
		}

		recentEvents.set( key, now );

		return false;
	}

	function send( event ) {
		if ( ! event || ! event.event_name ) {
			return Promise.resolve();
		}

		if ( isDuplicate( event ) ) {
			return Promise.resolve();
		}

		event.request_uri =
			window.location.pathname +
			window.location.search +
			window.location.hash;

		return window
			.fetch( endpoint, {
				method: 'POST',
				credentials: 'same-origin',
				keepalive: true,
				headers: {
					'Content-Type': 'application/json',
					'X-SweettySpace-Analytics-Token': token,
				},
				body: JSON.stringify( event ),
			} )
			.catch( function () {
				return null;
			} );
	}

	function handleClick( event ) {
		const target = event.target.closest( '[data-analytics-event]' );

		if ( ! target ) {
			return;
		}

		send( readDataset( target ) );
	}

	function handleSubmit( event ) {
		const form = event.target;
		const eventName = form.getAttribute( 'data-analytics-submit-event' );

		if ( ! form || ! eventName ) {
			return;
		}

		send( {
			event_name: eventName,
			entity_type:
				form.getAttribute( 'data-analytics-entity-type' ) || 'site',
			entity_id: toInt( form.getAttribute( 'data-analytics-entity-id' ) ),
			bakery_id: toInt( form.getAttribute( 'data-analytics-bakery-id' ) ),
			product_id: toInt(
				form.getAttribute( 'data-analytics-product-id' )
			),
			source_group: form.getAttribute( 'data-analytics-source' ) || '',
			payload: {
				form_name: form.getAttribute( 'name' ) || '',
				form_id: form.getAttribute( 'id' ) || '',
			},
		} );
	}

	document.addEventListener( 'click', handleClick, true );
	document.addEventListener( 'submit', handleSubmit, true );

	window.SweettySpaceAnalytics = {
		track: send,
	};
} )( window, document, window.SweettySpaceAnalyticsConfig );
